import { render, staticRenderFns } from "./CharPicker.vue?vue&type=template&id=ddbe4288&"
import script from "./CharPicker.vue?vue&type=script&lang=js&"
export * from "./CharPicker.vue?vue&type=script&lang=js&"
import style0 from "./CharPicker.vue?vue&type=style&index=0&id=ddbe4288&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports